const styles = (theme) => ({
    container: {},
    containerOrder: {
        margin: '5px 0',
    },
    colorAguardando: {
        color: theme.palette.primary.light,
    },
    colorEmAnalise: {
        color: theme.palette.primary.main,
    },
    colorEmConstrucao: {
        color: theme.palette.secondary.light,
    },
    centerProgress: {
        textAlign: 'center',
        margin: '30px 0 10px',
    },
});

export default styles;
